import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PaymentService } from '../../shared/payment/services/payment.service';
import { TeamDetails } from '@tokenbox/domain';
import { environment } from '../../../environments/environment.development';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import {
  Button,
  ButtonDirective,
  ButtonIcon,
  ButtonLabel,
} from 'primeng/button';
import { AutoFocus } from 'primeng/autofocus';
import { PrimeIcons } from 'primeng/api';

@Component({
  selector: 'dt-permission-denied-modal',
  templateUrl: './permission-denied-dialog.component.html',
  styleUrls: ['./permission-denied-dialog.component.scss'],
  imports: [Button, ButtonDirective, AutoFocus, ButtonIcon, ButtonLabel],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermissionDeniedDialogComponent {
  data = inject(DynamicDialogConfig).data as {
    text: string;
    team: TeamDetails;
  };

  protected readonly PrimeIcons = PrimeIcons;
  private paymentService = inject(PaymentService);
  private dialogRef = inject(DynamicDialogRef);

  upgradeUrl = this.data.team.plan.paidPlan
    ? this.paymentService.customerPortalUrl
    : this.paymentService.buildCheckoutUrlForCurrentUser(this.data.team.id);

  salesEmailAddress = environment.contact.email;

  close() {
    this.dialogRef.close();
  }
}
